"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ExtendedDataset_1 = __importDefault(require("./ExtendedDataset"));
/**
 * A DatasetFactory that creates an ExtendedDataset given a DatasetCoreFactory.
 */
var ExtendedDatasetFactory = /** @class */ (function () {
    function ExtendedDatasetFactory(datasetCoreFactory) {
        this.datasetCoreFactory = datasetCoreFactory;
    }
    ExtendedDatasetFactory.prototype.dataset = function (quads) {
        return new ExtendedDataset_1.default(
        // The typings are incorrect on the dataset core factory
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.datasetCoreFactory.dataset(quads), this.datasetCoreFactory);
    };
    return ExtendedDatasetFactory;
}());
exports.default = ExtendedDatasetFactory;
